import React from 'react';
import { ModalBody } from './Body.component';
import { ModalFooter } from './Footer.component';
import { ModalHeader } from './Header.component';
import { Modal as PrimaryModal, ModalContext } from './Modal.component';
import { IBoxProps } from '../containers/Container/Box.component';
import { IFlexProps } from '../containers/Flex/Flex.component';
import { IGroupProps } from '../containers/Group/Group.component';

export { ConfirmModal } from './ConfirmModal';
export type { IConfirmModalProps } from './ConfirmModal';

export type { IModalProps } from './Modal.component';

type ModalProps = typeof PrimaryModal & {
  Header: React.ComponentType<IBoxProps>;
  Body: React.ComponentType<IFlexProps & { fullWidth?: boolean }>;
  Footer: React.ComponentType<IGroupProps>;
};

Object.defineProperty(PrimaryModal, 'Header', { value: ModalHeader });
Object.defineProperty(PrimaryModal, 'Body', { value: ModalBody });
Object.defineProperty(PrimaryModal, 'Footer', { value: ModalFooter });

export const Modal = PrimaryModal as ModalProps;

export { ModalContext };
